import React, { useState, useEffect } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { RESEARCH_TYPE } from "../../utils/consts";
import { Spin } from "antd";

import englishJson from '../../utils/language/leStudy/english.json';
import spanishJson from '../../utils/language/leStudy/spanish.json';
import noLanguageJson from '../../utils/language/leStudy/noLanguage.json';

const GOOGLE_PLAYSTORE_LINK='https://play.google.com/store/apps/details?id=com.rnealsapp&hl=en_IN';
const APPLE_STORE_LINK='https://apps.apple.com/us/app/everythingals-app/id1666867278';

const DownloadEverythingAlsApp = (props) => {
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, []);
    let formData = RESEARCH_TYPE === "LE Study"
      ? props.language === "English"
        ? englishJson
        : props.language === "Spanish"
          ? spanishJson
          : noLanguageJson
      : englishJson;
    return (
      <div>
        <Header />
        <Spin spinning={loading}>
            <div
                className="main-content demographics-wrapper"
                style={{ paddingTop: 40 }}
            >
                <div className="container" style={{ minHeight: 300 }}>
                    <div className="row">
                    <div className="col-lg-10 m-auto">
                        <a onClick={() => window.history.back()} className="dashboard-back-arrow mt-0">
                        <box-icon
                            name="chevron-left"
                            color="#fff"
                            style={{ position: "relative", top: 1 }}
                        ></box-icon>
                        {formData.page.backButtonTextDashboard}
                        </a>
                        <div className="download-eals-app-wrapper">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="heading-block">
                                        <h4 className="mb-0 pb-0">{formData.page.downloadEverythingALSApp.title}</h4>
                                    </div>

                                    <div className="instruction-block">
                                        <div className="d-flex justify-content-between row">
                                            <div className="instructions col-lg-8">
                                                <h4>{formData.page.downloadEverythingALSApp.section1.title}</h4>
                                                <ul>
                                                    {formData.page.downloadEverythingALSApp.section1.options.map((option, index) => (
                                                        <li key={index}>{option}</li>
                                                    ))}
                                                </ul>
                                                <div className="buttons">
                                                    <a class="download-app-btn apple" href={APPLE_STORE_LINK}
                                                            target="_blank">
                                                        <div className="share-button">
                                                            <img src={'./assets/images/le-study/apple-button.png'} />
                                                        </div>
                                                    </a>
                                                    <a class="download-app-btn google" href={GOOGLE_PLAYSTORE_LINK} target="_blank">
                                                        <div className="share-button">
                                                            <img src={'./assets/images/le-study/google-play-store-button.png'} />
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-lg-3">
                                                <img src="./assets/images/le-study/download-eals-app-qr-code.png" className="mb-3"/>
                                                <p className="show-me-text">{formData.page.downloadEverythingALSApp.section1.showMe}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="instruction-block">
                                        <div className="d-flex justify-content-between">
                                            <div className="instructions">
                                                <h4>{formData.page.downloadEverythingALSApp.section2.title}</h4>
                                                <ul>
                                                    {formData.page.downloadEverythingALSApp.section2.options.map((option, index) => (
                                                        <li key={index}>{option}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="instruction-block">
                                        <div className="d-flex justify-content-between">
                                            <div className="instructions completing-session">
                                                <h4>{formData.page.downloadEverythingALSApp.section3.title}</h4>
                                                <ul>
                                                    {formData.page.downloadEverythingALSApp.section3.options.map((option, index) => (
                                                        <li key={index}>{option}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    

                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <Footer />
        </Spin>
      </div>
    );
}

export default DownloadEverythingAlsApp;